import { initSubRoutes } from '../../../../utils/router';

const RouteDemandeLoginOublie = initSubRoutes({
    route: '/demande',
    subroutes: {},
    nom: 'Demande de récupération de login oublié',
});

export default RouteDemandeLoginOublie;
